// utils/changeAuthType.ts
'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export function useChangeAuthType() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (newType: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('type', newType);
    router.push(`${pathname}?${params.toString()}`);
  };
}
